export default __webpack_public_path__ + "static/media/bubble-orange.42597c07.png";